import classNames from 'classnames';
import React from 'react';
import styles from "./tag-list.module.css";
/** React prop interface for the `TagList` component */

/**
 * ### TagList
 *
 * A list of `Tag` components to display.
 */
export const TagList = _ref => {
  let {
    tags
  } = _ref;
  return /*#__PURE__*/React.createElement("ul", {
    className: classNames(styles.list)
  }, tags.map((tag, index) => /*#__PURE__*/React.createElement("li", {
    key: index
  }, tag)));
};
//# sourceMappingURL=tag-list.react-component.js.map